import { Controller } from "@hotwired/stimulus"

// ロープレ受付フォーム:
// - 受験者情報（お名前・メール・電話・現年収）がすべて正しく埋まるまで開始ボタンを無効化する。
//   未入力のまま押せそうに見えるのを防ぐ（送信可否はフォームの checkValidity で判定）。
// - required / type=email / min など、input側の制約をそのまま活かす。
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.update()
  }

  // 入力のたびに、フォーム全体が妥当なときだけ開始ボタンを活性化する。
  update() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = !this.element.checkValidity()
  }
}
